
<form [formGroup]="formG1">

	<div class="twoFields">

		<div style="flex-grow: 1;">

			<triv-input [fGroup]="formG1" [data]="myInputs.name"></triv-input>

			<div
				*ngIf="bIsDuplicate"
				class="uniqueMsg"
			>
				<span class="material-icons" style="vertical-align: bottom;">report_problem</span>
				Eine andere Rubrik hat bereits diesen Namen!
			</div>

		</div>

		<triv-input [fGroup]="formG1" [data]="myInputs.active"></triv-input>

		<triv-input [fGroup]="formG1" [data]="myInputs.userSubscribable"></triv-input>

	</div>


	<div
		*ngIf="!group.id"
		style="margin-top: 4em; display: flex; flex-flow: row; justify-content: flex-end; gap: 2em;"
	>

		<!--
		<button mat-raised-button 
			*ngIf="group.id"
			color="warn"
			[disabled]="bInProgress"
			(click)="delete()"
		>
			<span class="material-icons">delete</span>
			Löschen
		</button>
		-->

		<!--
		<button mat-raised-button 
			[disabled]="formG1.pristine || bInProgress"
			(click)="reset()"
		>
			<span class="material-icons">history</span>
			Zurücksetzen
		</button>
		-->


		<button mat-raised-button 
			*ngIf="!group.id"
			[disabled]="bSaving"
			(click)="cancel()"
		>
			<span class="material-icons">undo</span>
			Abbrechen
		</button>

		<button mat-raised-button
			color="primary" 
			(click)="save()" 
			[disabled]="!formG1.valid || formG1.pristine || bSaving"
		>
			<span class="material-icons">save</span>
			Erstellen
		</button>

	</div>

</form>
